import { makePermissionDbHelpers, makePermissionHelpers, makePermissionSystem } from './abstract';
const permissionTypes = ['ArcRole', 'AuditLog', 'Build', 'Databases', 'Deployment', 'Deployment/Group', 'Deployment/Pipeline', 'Job', 'LinqSync', 'Member', 'OnCallSchedule', 'Restore', 'Role', 'User'];
const actionTypes = ['list', 'view', 'create', 'update', 'archive'];
/**
 * The permission meta data for most permission types.
 */
const standard = {
  list: {},
  view: {
    needs: 'list'
  },
  create: {
    needs: 'view'
  },
  update: {
    needs: 'view'
  },
  archive: {
    needs: 'update'
  }
};
const system = makePermissionSystem({
  permissionTypes,
  actionTypes,
  superPerms: [['User', 'create'], ['User', 'update'], ['User', 'archive']],
  permissionsMetadata: {
    ArcRole: {
      ...standard
    },
    AuditLog: {
      ...standard,
      create: 'unused',
      update: 'unused',
      archive: 'unused'
    },
    Build: {
      ...standard,
      archive: 'unused'
    },
    Databases: {
      ...standard,
      list: 'unused'
    },
    Deployment: {
      ...standard,
      archive: 'unused'
    },
    'Deployment/Group': standard,
    'Deployment/Pipeline': standard,
    Job: {
      list: {},
      view: {},
      create: {},
      update: 'unused',
      archive: 'unused'
    },
    LinqSync: {
      ...standard,
      list: 'unused',
      create: 'unused',
      archive: 'unused'
    },
    Member: standard,
    OnCallSchedule: standard,
    Restore: {
      ...standard,
      update: 'unused',
      archive: 'unused'
    },
    Role: standard,
    User: standard
  }
});
const helpers = makePermissionHelpers(system);
const dbHelpers = makePermissionDbHelpers(system, {
  ArcRole: 13,
  AuditLog: 11,
  Build: 5,
  Databases: 10,
  Deployment: 6,
  'Deployment/Group': 7,
  'Deployment/Pipeline': 12,
  Job: 4,
  LinqSync: 8,
  Member: 3,
  OnCallSchedule: 14,
  Restore: 9,
  Role: 2,
  User: 1
});

// For convenience, flatten all of these things into one object.
export const permissionSystem = {
  ...system,
  ...helpers,
  ...dbHelpers
};

// eslint-disable-next-line @typescript-eslint/no-namespace